export const primaryColor = '#003475'
export const primaryColorLight = '#1a68c7'
export const primaryColorDark = '#011a38'
export const primaryColorContrastText = '#fff'

export const secondaryColor = '#00afe4'
export const secondaryColorLight = '#46caf2'
export const secondaryColorDark = '#0283ab'
export const secondaryColorContrastText = '#fff'

export const greys = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#939393',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
}
